// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__21iy2","itemTitle":"ClientEmergencyInfo_itemTitle__3pd3l","itemText":"ClientEmergencyInfo_itemText__1YGua"};